import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { DEMO_VIDEO as DEMO_VIDEO_PATH } from '../../../../constants/paths';
import { messages } from '../../../../i18n';

const Root = styled.div`
  width: calc(${globalTheme.spacing.lg} * 25);
  /* Adding 1px because otherwise the video is glitching and showing scrollbar. */
  height: calc(${globalTheme.spacing.lg} * 14 + 1px);
  margin-top: ${globalTheme.spacing.lg};
  margin-left: calc(${globalTheme.spacing.lg} * 4);
  border-radius: 8px;
  overflow: hidden;
`;

export const Video: FC = () => {
  const { formatMessage } = useIntl();
  const analytics = useAnalytics();

  return (
    <Root>
      <iframe
        src={DEMO_VIDEO_PATH}
        width="100%"
        height="100%"
        allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
        allowFullScreen
        frameBorder="0"
        title={formatMessage(messages['landing.header.videoTitle'])}
        onClick={() => analytics('play', 'introduction video')}
        data-test="header-video"
      >
      </iframe>
    </Root>
  );
};
